var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path, _path2, _path3, _circle8, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgActivityTracking = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8.9,
  cy: 16.8,
  r: 0.7,
  fill: "#00CFB3"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.2,
  cy: 14.3,
  r: 0.7,
  fill: "#00CFB3"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.5,
  cy: 10.3,
  r: 0.8,
  fill: "#00CFB3"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.6,
  cy: 14.8,
  r: 0.8,
  fill: "#00CFB3"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 4.5,
  cy: 11.8,
  r: 0.7,
  fill: "#00CFB3"
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.2,
  cy: 20.1,
  r: 0.7,
  fill: "#00CFB3"
})), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
  cx: 16.9,
  cy: 20.1,
  r: 0.7,
  fill: "#00CFB3"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#00CFB3",
  d: "m10.9 20.5-2.7-3.7 3.6-2.7 2 3.2 3.3 2.1-.6.9-3.5-2.2-1.5-2.6L9.6 17l2.1 2.9z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#00CFB3",
  d: "m11.2 15-1.9-4.2c-.1-.2-.1-.5.1-.7.2-.1.4-.1.7-.1l4.5 1.9 1.1 2.2-.9.5-1-1.9-3.2-1.3 1.5 3.2zm-1.5-4"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#00CFB3",
  d: "m7.3 12.9-2.8-.6.2-1 2.3.5L9.2 10l.6.8z"
})), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.9,
  cy: 7.8,
  r: 1.5,
  fill: "#00CFB3"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M22.2 16.8h-7.9c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h7.9c.3 0 .5.2.5.5s-.2.5-.5.5"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#00CFB3",
  d: "M20 18.6h-3.1c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H20c.3 0 .5.2.5.5s-.2.5-.5.5"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#42A5F2",
  d: "M21.5 22.6h-2.9c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h2.9c.1 0 .2-.1.2-.2v-2.9c0-.3.2-.5.5-.5s.5.2.5.5v2.9c0 .7-.5 1.2-1.2 1.2M7.7 22.6H4.8c-.6 0-1.2-.5-1.2-1.2v-2.9c0-.3.2-.5.5-.5s.5.2.5.5v2.9c0 .1.1.2.2.2h2.9c.3 0 .5.2.5.5s-.3.5-.5.5M22.2 8c-.3 0-.5-.2-.5-.5V4.6c0-.1-.1-.2-.2-.2h-2.9c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h2.9c.6 0 1.2.5 1.2 1.2v2.9c0 .2-.2.5-.5.5M4.1 8c-.3 0-.5-.3-.5-.5V4.6c0-.6.5-1.2 1.2-1.2h2.9c.3 0 .5.2.5.5s-.3.5-.5.5H4.8c-.1 0-.2.1-.2.2v2.9c0 .2-.2.5-.5.5"
})));
export default SvgActivityTracking;